<template><svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
  <path d="M4 14v-2a8 8 0 0 1 16 0v2" />
  <path d="M4 14a2 2 0 0 0 2 2h1v-5H6a2 2 0 0 0-2 2Z" />
  <path d="M20 14a2 2 0 0 1-2 2h-1v-5h1a2 2 0 0 1 2 2Z" />
  <path d="M18 16a5 5 0 0 1-5 4" />
</svg></template>

<script>
export default {}
</script>